import { getLang } from "helpers/themeHelpers";
import { urlHelper } from "helpers/themeHelpers";
import {
  AUTO_SERVICES_BASE_PREFIX_AR,
  AUTO_SERVICES_BASE_PREFIX_EN,
  AUTO_SERVICES_BRANDS_PREFIX_AR,
  AUTO_SERVICES_BRANDS_PREFIX_EN,
  AUTO_SERVICES_DETAILS_PREFIX_AR,
  AUTO_SERVICES_DETAILS_PREFIX_EN,
  AUTO_SERVICES_SERVICES_PREFIX_AR,
  AUTO_SERVICES_SERVICES_PREFIX_EN,
  ISelectedAutoServiceCenterObjects,
} from "dataLayer/filters/autoServicesCenters";
import { qsStringify } from "helpers/globalHelpers";
import { IServiceCenter } from "models/autoServices";

export const linkToAutoServiceCenterDetails = (
  serviceCenterDetails: IServiceCenter
) => {
  const lang = getLang();
  return `/${lang}/${lang === "en" ? AUTO_SERVICES_BASE_PREFIX_EN : AUTO_SERVICES_BASE_PREFIX_AR}/${
    lang === "en"
      ? AUTO_SERVICES_DETAILS_PREFIX_EN
      : AUTO_SERVICES_DETAILS_PREFIX_AR
  }/${serviceCenterDetails.id}-${urlHelper(serviceCenterDetails)}`;
};

export const linkToAutoServiceCenters = (
  selectedObjects: ISelectedAutoServiceCenterObjects = {},
  page: number = null
) => {
  const lang = getLang();
  const { city, neighborhood, carMake, service } = selectedObjects;

  const urlParts = [
    lang,
    lang === "en" ? AUTO_SERVICES_BASE_PREFIX_EN : AUTO_SERVICES_BASE_PREFIX_AR,
  ];
  if (city) {
    urlParts.push(urlHelper(city));
  }
  if (neighborhood) {
    urlParts.push(urlHelper(neighborhood));
  }
  if (selectedObjects?.pageType === "services") {
    urlParts.push(
      lang === "en"
        ? AUTO_SERVICES_SERVICES_PREFIX_EN
        : AUTO_SERVICES_SERVICES_PREFIX_AR
    );
    urlParts.push(urlHelper(service));
  }
  if (selectedObjects?.pageType === "carMakes") {
    urlParts.push(
      lang === "en"
        ? AUTO_SERVICES_BRANDS_PREFIX_EN
        : AUTO_SERVICES_BRANDS_PREFIX_AR
    );
  }

  if (carMake) urlParts.push(urlHelper(carMake));
  return "/" + urlParts.filter(part => part.length > 0).join("/") + qsStringify({ page });
};

export const browseNowCarsLink = (mainCatUrlName?:string) => {
  const lang = getLang();
  mainCatUrlName = mainCatUrlName || (lang == "ar" ? 'سيارات-ومركبات' : 'cars');
  const pageName =
    lang === "ar" ? `${mainCatUrlName}/سيارات-للبيع` : `${mainCatUrlName}/cars-for-sale`;
  return `/${lang}/${pageName}`;
};
